export const iconFontAwesomePoliticalBuildingFlag = (
	<i className="fa-solid fa-building-flag"></i>
);
